import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'

@Component({
  selector: 'dmmp-website-card-program',
  templateUrl: './website-card-program.component.html',
})
export class WebsiteCardProgramComponent implements OnInit {
  @Input() program
  @Input() differenceDays: string
  @Input() urlPayment: string
  @Input() privateKey: string
  @Input() programId: string
  @Input() programPrice: string
  @Input() programExpiration: string
  @Input() labelCategory: string
  @Input() labelPrice: string
  @Output() page = new EventEmitter()
  labelFlag: string
  labelFlagCss: string

  ngOnInit() {
    this.getNewProgram(this.program.created_at, this.program.flag)
  }

  getNewProgram(creationDate, flag) {
    if (flag != null) {
      this.labelFlag = flag.toString().replace('_', ' ')
      this.labelFlagCss = flag.toString().replace('_', '-')
    } else {
      const cmsDate = new Date(creationDate * 1000)
      const localDate = new Date()
      const utcCmsDate = Date.UTC(
        cmsDate.getFullYear(),
        cmsDate.getMonth(),
        cmsDate.getDate(),
      )
      const utcLocalDate = Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate(),
      )
      const diffDays = Math.floor(
        (utcLocalDate - utcCmsDate) / (1000 * 60 * 60 * 24),
      )
      if (diffDays <= parseInt(this.differenceDays, 0)) {
        this.labelFlag = 'new'
      }
    }
  }
}
